import { render, staticRenderFns } from "./image-picker.vue?vue&type=template&id=d38ca87e&scoped=true&"
import script from "./image-picker.vue?vue&type=script&lang=js&"
export * from "./image-picker.vue?vue&type=script&lang=js&"
import style0 from "./image-picker.vue?vue&type=style&index=0&id=d38ca87e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38ca87e",
  null
  
)

export default component.exports